import autosize from 'autosize';
import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineCheck, HiOutlineTrash } from "react-icons/hi2";
import { TbPencil } from 'react-icons/tb';

const FacebookComments = ({ comment, user_image, integration, company, network, user_name, updateComment, deleteComment, isEditable }) => {
    const [commentText, setCommentText] = useState(comment.text || "");
    const [isEditing, setIsEditing] = useState(!comment.saved);
    const textareaRef = useRef(null);

    useEffect(() => {
        setCommentText(comment.text || "");
    }, [comment.text]);

    const handleCommentChange = (e) => { 
        const newText = e.target.value;
        setCommentText(newText);
    };

    const handleSaveComment = () => {
        if (commentText.trim() == "") {
            return;
        }
        updateComment(commentText);
        setIsEditing(false);
    };

    useEffect(() => {
        if (textareaRef.current) autosize(textareaRef.current);
    }, [textareaRef.current, isEditing]);

    return (
        <div className="flex items-start p-3 mb-2">
            <img 
                src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} 
                className="h-8 w-8 rounded-full mr-3" 
                alt="User" 
            />
            <div className="flex-1">
                <div className="flex place-content-between">
                    <div className={`text-tertiary-700 bg-tertiary-100 border rounded-3xl py-2 px-3 w-full flex flex-col ${isEditing ? "w-[90%]" : "max-w-[90%]"}`}>
                        <div className="flex items-center justify-between">
                            <span className="font-semibold text-sm text-tertiary-800">{user_name || integration?.name || company?.name}</span>
                        </div>
                        <div className="mt-1 w-full">
                            {isEditing ? (
                                <textarea
                                    ref={textareaRef}
                                    type="text"
                                    className="text-sm text-tertiary-700 dark:text-tertiary-300 bg-transparent border-none focus:outline-none flex-grow w-full"
                                    value={commentText}
                                    placeholder="Write a comment!"
                                    onChange={handleCommentChange}
                                    autoFocus
                                    onBlur={() => handleSaveComment()}
                                />
                            ) : (
                                <span 
                                    className={`group text-sm text-tertiary-700 block bg-transparent w-full max-w-[90%] ${isEditable ? "cursor-pointer" : ""}`}
                                    onClick={() => isEditable && setIsEditing(true)}
                                >
                                    <span className='group-hover:!bg-tertiary-200 dark:group-hover:!bg-tertiary-900 whitespace-pre-wrap'>
                                        {commentText}
                                    </span>
                                    {isEditable && (<>
                                        {" "}<TbPencil className="text-tertiary-600 ml-0.5 hidden group-hover:inline" />
                                    </>)}
                                </span>
                            )}
                        </div>
                    </div>
                    {isEditable && (
                        <div className="flex items-center">
                            <button
                                className="text-red-500 hover:text-red-600 ml-2"
                                onClick={deleteComment}
                            >
                                <HiOutlineTrash className="h-5 w-5" />
                            </button>
                        </div>
                    )}
                </div>
                <div className="flex items-center text-xs dark:text-gray-400 mt-1">
                    <span className="mr-3">0 hour</span>
                    <span className="mr-3 font-semibold">Like</span>
                </div>
            </div>
        </div>
    );
};

export default FacebookComments;